import { Component, OnInit } from '@angular/core'
import { DataPageOfDocument, Category, UiPreferences, ImageModels } from '../../../../../api/models'
import { UntypedFormBuilder } from '@angular/forms'
import { AppSettingService, DocumentService, ImageService } from '../../../../../api/services'
import { MessageService, ConfirmationService } from 'primeng/api'
import { Router, ActivatedRoute } from '@angular/router'
import { Customsort } from '../../../../directives/customsort'
import { DomSanitizer } from '@angular/platform-browser'
import { environment } from '../../../../../../environments/environment'
import { DatePipe } from '@angular/common'
import { SelectedPatientService } from '../../patient-list/patient-service'
import { combineLatest, map, mergeMap, of, timeoutWith } from 'rxjs'
import { CareFinitySession } from '../../../../services/CareFinitySession'
import { getLabelAndCount } from 'src/app/carefinity/services/docUtils'

@Component({
  selector: 'app-iamge-list',
  templateUrl: './cat-image.component.html',
  styleUrls: ['./cat-image.component.css'],
})
export class CatImageComponent implements OnInit {
    Item = 'Documents'
    distinctCatList: Array<Category> = []
  distinctcatresult: any
  arrdocdetails: DataPageOfDocument
  User: any
  imageHeader: string = ''
  rows: number
  private cols: any[]
  gridHeader: string = ''
  displaypopup: boolean = false
  pdfSrc: any
  href: string
  visible: boolean
  activeItem
    selectedCategoryId: any;
    preferences: UiPreferences = {};
    first = 0;
  constructor(
    private selectedPatientService: SelectedPatientService,
    private fb: UntypedFormBuilder,
    private imageService: ImageService,
    private docservice: DocumentService,

    private messageService: MessageService,
    private confirmation: ConfirmationService,
    private datePipe: DatePipe,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private cstsort: Customsort,
    protected sanitizer: DomSanitizer,
    private appSettingsService: AppSettingService,
  ) {}

  ngOnInit() {
    this.cols = [
      // { field: 'visitDate', header: 'Visit Date' },
      { field: 'displayDescription', header: 'Description' }
      // { field: 'createdbyName', header: 'Created By' },
      // { field: 'createdOn', header: 'Create Date' },
      // { field: 'format', header: 'Format' },
    ]

      this.LoaddistinctImageList();

     

      const storedPreferences = localStorage.getItem('uiPreferences');
      if (storedPreferences) {
          this.preferences = JSON.parse(storedPreferences);

          this.Item = this.preferences?.images || 'Documents';
      }
  }
  LoaddistinctImageList(): void {
    this.imageService
      .imageGetcategorylistbypatient({
        patientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
      })
        .subscribe((result) => {
            this.distinctCatList = [...this.distinctCatList, ...result]

        if (result.length > 0) {
            this.loadimageList(1, '', this.distinctCatList[0].categoryId)
            this.activeItem = this.distinctCatList[0]
            this.selectedCategoryId = this.distinctCatList[0].categoryId
        }
      })
  }
  loadimageList(
    pageNumber: number,
    sortbydirection: string,
    categoryId: string,
  ) {


          this.imageService
              .imageGetAllImageList({
                  patientId: sessionStorage.getItem('ptId'),
                  emrpracticeId: localStorage.getItem('EmrPracticeId'),
                  pageNumber: pageNumber,
                  category: categoryId,
              })
              .subscribe((result) => {
                  this.arrdocdetails = result



                  ///console.log(result);
                  this.rows = this.arrdocdetails.pageSize
              })
      
  }
    Setitem(cat) {
        this.first = 0;
    this.loadimageList(1, '', cat.categoryId)
    this.selectedCategoryId = cat.categoryId
  }

  getdocumnetdetails(obj) {}


  formatdatetime(item, type) {
    if (item != null && type.indexOf('Date') > -1) {
      return this.datePipe.transform(item, environment.datetimeformat)
    }
    return item
  }

  viewDoc(obj: any) {
  this.getImageDetails(obj);
  }
  back() {
    window.history.back()
  }

    getImageDetails(obj) {
      this.User = JSON.parse(localStorage.getItem('currentUser'))
  
      return this.imageService
        .imageDetail({
          DocumentType: obj.documentType,
          InDataBase: obj.inDataBase,
          patientId: sessionStorage.getItem('ptId'),
          emrpracticeId: localStorage.getItem('EmrPracticeId'),
  
          Id: obj.documentID,
          FileType: obj.fileType,
          UserId: CareFinitySession.user.userID.toString(),
        })
        .pipe(
          map((imgDetails) => ({ ...obj, ...imgDetails })),
  
          mergeMap((docementDetails: ImageModels) => {
            if (docementDetails.errorMessage) {
              return of({ ...docementDetails, documentBlob: new Blob() })
            }
  
            return this.docservice
              .documentGetDocuments({
                fn: docementDetails.selectedPDF,
                PatientName: sessionStorage.getItem('ptName'),
              })
              .pipe(mergeMap((i) => of({ ...docementDetails, documentBlob: i })))
          }),
        )     .subscribe(
          (file) => {

            if(file.documentBlob.size==0){
              this.messageService.add({
                key: 'alertToast',
                severity: 'error',
                summary: 'ERROR',
                detail:
                  'Document File missing, Please Contact Technical Support',
              })
              return;
            }
            if (file.flexPaper) {
              this.router.navigate(['show-pdf'], {
                relativeTo: this.activatedRoute,
                state: {
                  pdf: file.documentBlob,
                    showPrintButton: CareFinitySession?.practiceSettings?.enablePatientDemographicPrint && CareFinitySession?.user?.roles?.patientRecordsPrint,
                    enabledDocumentDownloads: CareFinitySession?.practiceSettings?.enableDocumentDownloads && CareFinitySession?.user?.roles?.enableDocumentDownloads


                        
                },
              })
            } else {
              const binaryData = file.documentBlob
              const downloadLink = document.createElement('a')
              downloadLink.href = window.URL.createObjectURL(
                binaryData
              )
              downloadLink.target = '_blank'
              downloadLink.setAttribute('inline', 'arshid')
              document.body.appendChild(downloadLink)
              downloadLink.click()
              document.body.removeChild(downloadLink) // Clean up
            }
          },
          (err) => {
            this.messageService.add({
              key: 'alertToast',
              severity: 'error',
              summary: 'ERROR',
              detail:
                'Document File missing, Please Contact Technical Support',
            })
          },
        )
    }

        getLabelAndCount(item) {
        
           return  getLabelAndCount(item, this.distinctCatList);
        }
}
